export const getSortTranslation = (sort) => {
  const sortHash = {
    "Low to High": "الأقل إلى الأعلى",
    "High to Low": "الأعلى إلى الأقل",
    Newest: "الأحدث",
    Oldest: "الأقدم",
    "A to Z": "أ - ي",
    "Z to A": "ي - أ",
    Price: "السعر",
    Name: "الاسم",
    Date: "التاريخ",
  };
  return sortHash[sort];
};


export const isEqual = (a, b) => {
  return JSON.stringify(a) === JSON.stringify(b);
};
